import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation, useRoute } from '@react-navigation/core';
import React, { useEffect, useState } from 'react';
import { Text, TextInput, View } from 'react-native';
import GradientButton from "../../components/GradientButton";
import HeaderDefault from "../../components/HeaderDefault";
import NumberInput from '../../components/NumberInput';
import balanceService from '../../services/balanceService';
import feeService from '../../services/feeService';
import activesService from '../../services/activesService'
import { styles } from './styles';
import * as Clipboard from 'expo-clipboard';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { formatGPXBalance, formatCoin, maxDecimals } from '../../utils/formatNumber';
const WithdrawCrypto = () => {
  const navigation = useNavigation();
  const route = useRoute();
  const { crypto } = route.params;

  const [balance, setBalance] = useState(0);
  const [value, setValue] = useState(crypto.minValue);
  const [networkFee, setNetworkFee] = useState(0);
  const [fee, setFee] = useState(null);
  const [activeDecimalPlaces, setActiveDecimalPlaces] = useState(null);
  const [lastQuote, setLastQuote] = useState(0);
  const [wallet, setWallet] = useState('');

  const finalBalance = balance - value;

  useEffect(() => {
    loadBalance();
    loadFee();
    loadActive();
  }, []);

  async function pasteClipboard() {
    const clipboard = await Clipboard.getStringAsync();
    setWallet(clipboard);
  }

  const loadBalance = async () => {
    // console.log(crypto);
    try {
      const authToken = await AsyncStorage.getItem('JWT_TOKEN');
      const { data } = await balanceService.getBalanceOfToken(authToken, crypto.activeId);
      setBalance(parseFloat(data?.saldo + ''));
    } catch (err) {
      console.log(err);
    }
  }

  const loadFee = async () => {
    try {
      const authToken = await AsyncStorage.getItem('JWT_TOKEN');
      const { data } = await feeService.getWithdrawFeeByActiveId(authToken, crypto.activeId);
      setFee(data);
    } catch (err) {

    }
  }

  const loadActive = async () => {
    try {
      const authToken = await AsyncStorage.getItem('JWT_TOKEN');
      const { data } = await activesService.getById(authToken, crypto.activeId);
      if (data.actives.length > 0) {
        setLastQuote(parseFloat(data.actives[0].single_value));
        setActiveDecimalPlaces(data.actives[0].feezeroMk);
      }
    } catch (err) {
    }
  }

  const getFeeActive = () => {
    if (!fee || fee.currency !== 'active') return 0;
    return (fee.type === 'fixed' ? fee.fee : fee.fee * value)
  }

  const getFeeGpxBrl = () => {
    if (!fee || fee.currency === 'active') return 0;
    return (fee.type === 'fixed' ? fee.fee : fee.fee * value * lastQuote);
  }

  const getFinalGpxBrlBalance = () => {
    //TODO:
  }

  const getTransferReceiveValue = () => {
    return value - getFeeActive();

  }

  const getFinalActiveBalance = () => {
    return (balance - getTransferReceiveValue())+'';
  }

  return (
    <View style={{ flex: 1 }}>
      <HeaderDefault title={`Sacar ${crypto.acronym}`} />

      <View style={styles.container}>
        <View>
          <Text style={styles.infoText}>
            Para identificar o recebimento do {crypto.acronym}, é necessário que você nos informe o código da transação.
            Informe o código da transação no campo abaixo:
          </Text>

          <Text>
            Digite a quantidade desejada
          </Text>
          <View style={styles.inputContainer}>
            <NumberInput minValue={crypto.minValue} step={crypto.step} onChange={setValue} value={value}></NumberInput>
            {/* <TextInput style={styles.input} keyboardType="number-pad" defaultValue="0.1" /> */}
          </View>
          <View style={styles.summary}>
            <View style={styles.spaceBetween}>
              <Text style={styles.textBold}>Saldo atual</Text>
              <Text>{maxDecimals(balance, 8)} {crypto.acronym}</Text>
            </View>
            <View style={styles.spaceBetween}>
              <Text style={styles.textBold}>Saldo após o saque</Text>
              <Text>{maxDecimals(getFinalActiveBalance(), 8)} {crypto.acronym}</Text>
            </View>

            {
              fee && fee.currency === 'active' ?
                <View style={styles.spaceBetween}>
                  <Text style={styles.textBold}>Taxa</Text>
                  <Text>{formatCoin(getFeeActive(), activeDecimalPlaces)} {crypto.acronym}</Text>
                </View>
                :
                <View style={styles.spaceBetween}>
                  <Text style={styles.textBold}>Taxa</Text>
                  <Text>{formatGPXBalance(getFeeGpxBrl())} GPX/BRL</Text>
                </View>
            }
            <View style={styles.spaceBetween}>
              <Text style={styles.textBold}>Valor que será recebido</Text>
              <Text>{getTransferReceiveValue()} {crypto.acronym}</Text>
            </View>
          </View>
          <View style={styles.spaceBetween}>
            <Text style={styles.textBold}>Digite o código da carteira</Text>
            <TouchableOpacity onPress={pasteClipboard}>
              <Text style={styles.copyText}>
                Colar código
              </Text>
            </TouchableOpacity>
          </View>
          <View>
            <TextInput
              value={wallet}
              onChangeText={(text) => { setWallet(text) }}
              style={styles.walletInput} />
          </View>
        </View>

        {
          getFinalActiveBalance() < 0 ?
            <GradientButton onPress={() => navigation.navigate("DepositMethod")}>SALDO INSUFICIENTE</GradientButton>
            :
            (
              wallet.length === 0 ?
                <GradientButton>DIGITE UMA CARTEIRA</GradientButton>
                :
                <GradientButton onPress={() => navigation.navigate('WithdrawCryptoPassword', {
                  crypto: crypto,
                  value: value,
                  wallet: wallet
                })}>CONFIRMAR</GradientButton>
            )
        }
      </View>
    </View>
  );
}

export default WithdrawCrypto;